<template>
    <div class="filter-steps--container">
        <CustomerFilterOptionsNew
            class="filter-steps--choices filter-status"
            @onCustomerSelected="handleCustomerFilterChange"
            :filter-customer-id="customerIdFilterValue"
        />
        <ServiceAreaFilterOptions
            class="filter-steps--choices filter-status"
            @onSelectedServiceArea="handleServiceAreaFilterChange"
            :filter-service-area-id="serviceAreaFilterValue"
        />
        <ChargingTypeOptions
            class="filter-steps--choices filter-status custom-md-field"
            label-name=""
            @selectedOption="handleServicePackageChange"
            placeholder="Service Package"
        />
        <OrderDateFilterOptions @onDateFilterChanged="handleDateFilterChange" />
        <md-field class="status-filter">
            <vue-select
                data-testid="order-status"
                v-if="orderStatuses"
                :options="orderStatuses"
                placeholder="Status"
                v-model="filter.orderStatus"
                :searchable="$root.isDesktop"
                :clearable="false"
            ></vue-select>
        </md-field>
    </div>
</template>

<script>
import { ORDER_FULFILLMENT_STATUS_CONSTANTS, DATE_TYPES } from '@/utils/constants';
import { CustomerFilterOptionsNew, ServiceAreaFilterOptions, ChargingTypeOptions } from '@/components';
import { mapGetters } from 'vuex';
import moment from 'moment';
import OrderDateFilterOptions from '@/pages/Orders/components/OrderDateFilterOptions';

export default {
    name: 'OrderFilterMenu',
    components: { CustomerFilterOptionsNew, ServiceAreaFilterOptions, OrderDateFilterOptions, ChargingTypeOptions },
    props: {
        customerIdFilterValue: {
            type: Number,
            default: null
        },
        serviceAreaFilterValue: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapGetters({
            hasCustomerFilterAccess: 'user/hasInventoryListAccess'
        })
    },
    data() {
        return {
            orderStatuses: [],
            filter: {
                customerId: null,
                serviceAreaId: null,
                filterType: 'createdDate',
                dateRangeType: 'dateRange',
                fromDate: moment().format(DATE_TYPES.internationalDate),
                toDate: moment().add(14, 'days').format(DATE_TYPES.internationalDate),
                orderStatus: 'All',
                rateGroupId: null
            }
        };
    },
    mounted() {
        const statusNames = ORDER_FULFILLMENT_STATUS_CONSTANTS.map((status) => status.name);
        this.orderStatuses = ['All', ...statusNames];
    },
    watch: {
        'filter.orderStatus': function(newVal) {
            this.handleOrderStatusFilterChange(newVal);
        }
    },
    methods: {
        handleCustomerFilterChange(customerId) {
            this.filter.customerId = customerId;
            this.$emit('handleFilterChange', this.filter);
        },
        handleServiceAreaFilterChange(serviceAreaId) {
            this.filter.serviceAreaId = serviceAreaId;
            this.$emit('handleFilterChange', this.filter);
        },
        handleOrderStatusFilterChange(status) {
            this.filter.orderStatus = status;
            this.$emit('handleFilterChange', this.filter);
        },
        handleDateFilterChange({ filterType, dateRangeType, fromDate, toDate }) {
            this.filter.filterType = filterType;
            this.filter.dateRangeType = dateRangeType;
            this.filter.fromDate = fromDate;
            this.filter.toDate = toDate;
            this.$emit('handleFilterChange', this.filter);
        },
        handleServicePackageChange(servicePackage) {
            if (servicePackage !== undefined) {
                this.filter.rateGroupId = servicePackage?.rateGroupId ?? null;
                this.$emit('handleFilterChange', this.filter);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.filter-steps--container {
    flex-grow: 2;
    ::v-deep .md-field {
        min-height: 48px;
        margin-right: 20px;
        margin-top: 0;
        vertical-align: top;
    }

    ::v-deep > .md-field,
    .filter-status > ::v-deep .md-field,
    .custom-md-field {
        display: inline-block;
        width: 180px;
    }

    ::v-deep .vs__selected {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 116px;
        display: block;
    }

    .status-filter {
        width: 220px;

        ::v-deep .vs__selected {
            max-width: 200px;
        }
    }
}
</style>
